var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',{staticClass:"pa-0"},[_c('v-col',{staticClass:"text-start"},[_vm._v(" "+_vm._s(_vm.mappedPlace.full)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }